<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisPollution',
  routeInfo: {
    label: '污染分析',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/index.vue